import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { captureException } from '@sentry/react'
import locales from '../translations/locales.json'

const SUPPORTED_LANGUAGES = locales.map((locale) =>
	locale.languageCode.toLowerCase(),
)

i18n
	.use(initReactI18next)
	.use(LanguageDetector)
	.use(
		resourcesToBackend((language, namespace, callback) => {
			if (!SUPPORTED_LANGUAGES.includes(language.toLowerCase())) {
				callback(
					new Error(`Language '${language}' not found in translations folder`),
					null,
				)
				return
			}
			import(`${__dirname}/../translations/${language}/${namespace}.json`)
				.then((resources) => {
					callback(null, resources)
				})
				.catch((error) => {
					const minimumRetryDelayMs = 300
					const jitterMs = Math.floor(Math.random() * 100)
					const retryDelay = minimumRetryDelayMs + jitterMs
					console.warn(
						`i18n import failed for ${language}/${namespace}, retrying in 
						${retryDelay}ms...`,
						error,
					)
					// If retyr works this can be removed later
					captureException(error, {
						extra: {
							language,
							namespace,
							error: error.message,
							retry: true,
							hintMessage: `i18n import retry for ${language}/${namespace}`,
						},
						level: 'info',
					})

					setTimeout(() => {
						import(`${__dirname}/../translations/${language}/${namespace}.json`)
							.then((resources) => {
								callback(null, resources)
							})
							.catch((retryError) => {
								callback(retryError, null)
							})
					}, retryDelay)
				})
		}),
	)
	.init({
		fallbackLng: 'en-gb',
		ns: ['default', 'common', 'public-sector'],
		defaultNS: 'default',
		fallbackNS: 'common',
		interpolation: {
			escapeValue: false,
		},
		returnEmptyString: false,
		lowerCaseLng: true,
		keySeparator: false,
		react: {
			useSuspense: true,
		},
		initImmediate: false,
	})

i18n.on('languageChanged', (lng) => {
	document.documentElement.lang = lng
})

export default i18n
